<template>
	<div class="buy-module">
		<div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
		</div>
		<div class="pa-5">
			<p class="title primary--text font-weight-bold mt-2">
				<v-icon color="primary" class="mr-2">mdi-cart</v-icon>
				<translate>Cart</translate>
			</p>
			<p
				v-if="cartItems.length == 0"
				class="font-weight-thin ml-2"
				v-translate
				key="empty-car"
			>The cart is empty.</p>
			<template v-else>
				<v-row no-gutters>
					<v-col cols="12" md="12">
						<v-simple-table>
							<template v-slot:default>
								<template v-if="upgrade">
									<thead>
										<tr>
											<th></th>
											<th v-translate>Plan</th>
											<th v-if="cartItems[0].module" v-translate>Module</th>
											<th v-translate>Price</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in cartItems" :key="item.plan.id">
											<td><translate>Upgrade</translate></td>
											<td>{{ item.plan.name }}</td>
											<td v-if="item.module">{{ item.module.name }}</td>
											<td>
												<span :class="item.price != item.priceWithDiscount ? 'green--text' : ''">{{item.priceWithDiscount}}€</span>
												<span v-if="item.price != item.priceWithDiscount" style="text-decoration:line-through" class="ml-2 grey--text">{{item.price}}€</span>
											</td>
											<td>
												<v-row no-gutters>
													<v-spacer></v-spacer>
													<v-btn right icon small :disabled="paymentDone" @click="removeItem(item)">
														<v-icon small>delete</v-icon>
													</v-btn>
												</v-row>
											</td>
										</tr>
										<tr>
											<td></td>
											<td></td>
											<td v-if="cartItems[0].module"></td>
											<td>
												<strong>Total: </strong>
												<span :class="total.price != total.priceWithDiscount ? 'green--text' : ''">{{total.priceWithDiscount}}€</span>
												<span v-if="total.price != total.priceWithDiscount" style="text-decoration:line-through" class="ml-2 grey--text">{{total.price}}€</span>
											</td>
											<td></td>
										</tr>
									</tbody>
								</template>
								<template v-else>
									<thead>
										<tr>
											<th v-if="isSMS">SMS</th>
											<th v-else v-translate>Plan</th>
											<template v-if="!isSMS">
												<th v-if="cartItems[0].module" v-translate>Module</th>
												<th v-translate>Duration</th>
												<th v-translate>End Date</th>
											</template>
											<th v-translate>Price</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in cartItems" :key="item.plan.id">
											<td v-if="isSMS">{{ item.plan.quantity }}</td>
											<td v-else>{{ item.plan.name }}</td>
											<template v-if="!isSMS">
												<td v-if="item.module">{{ item.module.name }}</td>
												<td>
													<span v-if="$store.getters.spaceSubscriptionPlan.days_left > 0">
														{{$store.getters.spaceSubscriptionPlan.days_left}} <translate>Days</translate> (Plano Atual) + 
													</span>
													{{item.months}}
													<translate v-if="item.months == 1">Month</translate>
													<translate v-else>Months</translate>
													<span class="font-weight-bold" v-if="item.days > 0"> + {{item.days}} <translate>Days</translate></span>
												</td>
												<td>{{endDate}}</td>
											</template>
											<td>
												<span :class="item.price != item.priceWithDiscount ? 'green--text' : ''">{{item.priceWithDiscount}}€</span>
												<span v-if="item.price != item.priceWithDiscount" style="text-decoration:line-through" class="ml-2 grey--text">{{item.price}}€</span>
											</td>
											<td>
												<v-row no-gutters>
													<v-spacer></v-spacer>
													<v-btn right icon small @click="removeItem(item)">
														<v-icon small>delete</v-icon>
													</v-btn>
												</v-row>
											</td>
										</tr>
										<tr>
											<td></td>
											<template v-if="!isSMS">
												<td></td>
												<td></td>
											</template>
											<td v-if="cartItems[0].module"></td>
											<td>
												<strong>Total: </strong>
												<span :class="total.price != total.priceWithDiscount ? 'green--text' : ''">{{total.priceWithDiscount}}€</span>
												<span v-if="total.price != total.priceWithDiscount" style="text-decoration:line-through" class="ml-2 grey--text">{{total.price}}€</span>
											</td>
											<td></td>
										</tr>
									</tbody>
								</template>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>	
				<v-row no-gutters class="mt-2" v-if="!paymentDone">
					<v-col cols="5" offset="7">
						<v-form v-if="!hasDiscountCode" v-model="validForm" ref="discountCodeForm">
							<v-row no-gutters>
								<v-text-field
									v-model="discountCode"
									:placeholder="$gettext('Discount Code')"
									outlined
									class="px-2"
									:rules="[required]"
									dense
									:error-messages="invalidCode ? 'Cupão inválido' : invalidUpgradeCode ? 'Cupão válido apenas para extensão de plano.' : null "
								></v-text-field>
								<v-btn
									small
									class="mt-1"
									color="primary"
									@click="useCode"
									:loading="loadingCode"
								>
									<translate>Use</translate>
								</v-btn>
							</v-row>
						</v-form>
						<v-row v-else no-gutters align="center">
							<v-spacer>
							</v-spacer>
							<span class="mr-2 font-weight-bold">{{$store.getters.discountCode.code}}</span>
							<v-btn
								small
								color="primary"
								@click="removeCode"
								icon
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
				<v-btn
					v-if="!showPaymentMethods"
					color="primary"
					absolute
					right
					class="mt-6 mr-6"
					@click="showPaymentMethods = true"
				>
					<translate>Pay</translate>
				</v-btn>
				<template v-if="showPaymentMethods">
					<p class="title primary--text font-weight-bold mt-5">
						<v-icon color="primary" class="mr-2">mdi-credit-card-outline</v-icon>
						<translate>Payment</translate>
					</p>
					<v-expansion-panels class="px-6">
						<v-expansion-panel :disabled="paymentDone">
							<v-expansion-panel-header expand-icon="mdi-menu-down">
								<v-row no-gutters align="center">
									<img
										style="max-width:100px; max-height: 45px;"
										src="data:image/png;base64,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"
									/>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<template v-if="!MBPaymentDone">
									<v-btn color="white" class="mt-4" @click="makePaymentMB" :loading="MBLoading">
										<translate>Generate Reference</translate>
									</v-btn>
									<p class="my-4 font-weight-thin" key="no-tax">
										<b>
											<translate>Note</translate>:
										</b>
										<translate>In this procedure no fee will be charged.</translate>
									</p>
								</template>
								<template v-else>
									<template v-if="!MBPaymentError">
										<p>
											<b v-translate>Entity:</b>
											{{MBEntity}}
										</p>
										<p>
											<b v-translate>Reference:</b>
											{{MBReference}}
										</p>
										<p>
											<b v-translate>Amount:</b>
											{{MBAmount}} €
										</p>
										<p v-translate class="font-weight-thin">
											After you pay the bill and it is processed, you will have access to the plan. See the "Payments" section in the "Subscriptions" tab to see the status of your payment.
										</p>
									</template>
									<template v-else>
										<p v-translate class="font-weight-thin red--text">Error! Try again later</p>
									</template>
								</template>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel :disabled="paymentDone">
							<v-expansion-panel-header expand-icon="mdi-menu-down">
								<v-row no-gutters align="center">
									<img
										style="max-width:70px; max-height: 30px;"
										src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVUAAACxCAMAAABDcN48AAAAYFBMVEUAAADgIhIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgIhLgIhLgIhLgIhLgIhLgIhLgIhLgIhLgIhLgIhLgIhLgIhLgIhIAAADgIhKB9XIsAAAAHnRSTlMAwEDAgBDwoOAgYDDQsFCQcECAEPBg4DCZILDQcFBqUapfAAAK+klEQVR42uzZzW6DMBAE4EHOrUoq/2BDAO37v2WjBpW06qG92M5kvjuXkTWsvfhdHK/JmhjWCFIhWUMTZa7zYm3lAjolWWtpBJkOQr0hO61xsR4krm4N1ocriMzWCw8ek/ViAI3Yxa/qbgaL0foRwKKfAmCqgD7Gqh1YWE9oitV+GCrKrLNVsW+uETX5xJmqb3u9KekFUp1R28Sf6oDqvFK9UapK9c+U6hNQqp+U6jOwBxOqi/ypBtTH+Q6w2GFDfYMdMlis9iWhgZHy1fphw7KigZgpd9e+8ea4pKOAiPi8DwCNlHu1Z5oBYLeFsM5oZwshUB1UEREREREREXkxbyfn3Pl0+f93Z+fc+wXyQb65JEcKA0FUob8ECE6g+x9zNhOm6VRWAUN4weTK4UY0PFL1Mwa13P8qenNB9WddrmaoYGUV81aF1D80l9PrlsO6YEDWdVVzasG8T2HuB8XpqXW1n1NM77Ms+Cmf884Olbh16uf1Nq6+g5ab6xJ9XLriZl6kEjvKnljXtXWhX1N6UXj1fSBnVK29K2a1/aLm92DNfSQ9ysU+UjhQ/W+xkoyiBrnWh2oSVV3OvEOk+MlGUepDrRep4vpXyPexlJo1RN1stt/QO1pfd880lUXGf6WaXxFaXb8VApZOpFDV5c0LlG9txdCvUrVj1RQvlB84uTFExVrLgpi1dD8I857Q/HT6QjpTMoK2zjQRqsK5IjWrXjHnSSim3YjelGl8q5Eva/HwCayL9RTVKI8AmKxCVZ/SxEt5NgYhBTuaZr1BWaFhL5FnG8vvHFWlbpWqaVR1rO1S7NqkDmViuyyLxWKhm7Pw1JROUV0km1B5japepyVzSniZ+MUbTbNirvD0jlf+be7cBDRwmzxM1bQbISDTo1fBGRG9iigy/TAiFIdm8J2r8i6Xa2FUZTmtA+Eb1gpRPzJjJfkSJhpUPN0Y9hzVmSdfLnePaoXHqaqy+wwCHk+/oshByDOzOrhxZbBc6LiKa75HNai1FcXgpCfkCYMi54rIQ/8mW1WnuvEgyKVS1Wu15VoDw3M5IofASXJFo9TzeJnj54rYterjqvwIVUdR6IFV2kokrGq5YuG7qQ73heVNQMVGSR9XrRA2folqw12OfOzQcE2dbAZ6RCZWpVTtTAdXtBjL3+f4NaoBD8cE7IffEmiumPV0VolVme9Lha5VHVetv00VY3EQumk3eg4z9f3c4BAw60ysylorE/TBVYEokcEcN6giCV0rXiWO00bsVmqV7ce0hd+5RatK6RyMmAxog4zmHqDaLlZWHFLFcQ8+BpqKgklwEYDegVWlGOTgmmLQxlXbN9V0i+pykSrf0OkriXoeMvBRLHtQzMJ8wYJVJapY4VctABQ4yXWqmLevBlZMOxGQS2H1M0dlfhVuhy9Y1Sxgs6TUbSu0Uk9QnaGqkYSFEj6fBZBDKYZWiZ8nTYJZi2BVDIk4GgzyuKpiJLtBNZ2aP/C7XBF0HQTRlVDYQQJi8vQTWJV7xA+wbbBVAbr9V6oJvpKKNKB4RwVyGWtxYdNjyYqpsIBVeRNAtjgHsBikWi5SnWYI1VxsWIKhc/9RG8fsCQpSF+WfDj/qVCfxHjGZ4VmuUC11uf1WEA72diIr5DIYHaJVPJRZ3KyhjgEhwWlUOnmhvo3mOtWSYhdlDRcdQsPEBXIZTGPQKgVaAm5WT6yKe5eU+TwApJGBvUi1PvACGwLJ34Awl/E/ydTvUMG6VqSDVkXrsZb0R6Shdeep2q7Jmitajvc2HULiEU75+Yyco6J59YldImEJEpOjg6uKNsYFSaKaH34pcDsS8fvehVxWYV/TMJqEi/GyVWn9zgdXCxLAssEJVNtzL6+BOY91FeayhQyNN/Qwdq36X9kZpYXvczk2+NNUfQfd+qckbFAPV54xl+1Hspq9DQtY1MqtKgZEHFzxPIa/jwLV5cn/uAAH7nUVNAngauxWSbMFKoBGa63G+zSQcRUrJTjVtWuK7V5g3T7jYcMmYT+QWC8R1KikNCyw00mtT8ZVhGrgVLcHX2KHzL5fN+QyqBZws89/2DujJUlBGIpaoAIi4v9/7W7tPjDVIbkxQ00V3ZNHy27xNITcK9L+a0hLExLpqkBa8bqUdjTPFVyOp5oAUbateGEQHeTtQOhUtrpSr4hmcBYmUHqO6/bKyFqvaqpLGY41tNa3uoqIhAaYHc76xWY3oxKkfMgZV5m/3k7O5qhucRhWou5bGqUigV0KtIOm3MiARNJK9KZpWgC1BKNYN6/BejxPrL7VVR2RQIhDAS31R2KRYGnFGVc7mdsYqlX2rNxa/GuQSiA9f7OhGao9kUCIazNS+h5VLzzzq4xdxYorSlWM7YhWj6VZUa2uoiKBmFvq2bMCqsCDL/Lz6SCkvlVBFcVtNVmuV2+u1xdLI967aPQ02q0DqlhaseJ0Y60lKq5MVJe8Wzprq+t2vne02IBaxarVTpUaV4HYVaCYAFTHPb6mkk8oHs/+FXcpPwZMFUsrxrhi7CpGXJmoLqutuqrS9BKlJFnJYUa12qk6Mq6EyNLJzkCVINgfJdYWUZo7rv71sjgGjkdUkwRqKU+quEFUD1MK2KTueJBRRH+OKLemAKpYWrW4sOIA4gpQRXxWW2K9SNeBj+Fv0JptCFWs5RKa9zBVvIrVllilrFL7rn4C3u39hOoqvwQQ4HPQ8VRX0iAQ5EJFug3XHeEeJezTTtWTtgKZDsSVjSr8CJp2bylXo2erYKGAimoAGjHq7bF1ENXLRtULsj1xt5iYu2EqL0QViwDwOKQAuRmH91X8Mc2LVGu3zQHrkjiQauaoXmji+2mqTtIOlUmrnrkbUNAiqtDSPMF+DOOpehvVRXo95JLTalRYPnaqTr0PSICCwpnrVSPVAJdF0HYfirI49b/WE9YiCXqGciXUGKqrdRnbdgqLNA5mu7zQjoIWXV17LehFAFatUZlNMFW82EaP9S6+3IlJu8X7cm8UdygHrEqKD472t+D9sRipHow5Dmc+TBWbT3Pux8pIK2hc5SFU8W845+bBjLRCqvVUnOgtVIkvPmUQELzWwQNzxVTxPvBvkAAYEQCNq6RJJ0+p5kouNOkujCqqgVGrYOqjx7wQsVsUzxmMtAKq9TBQNcQ+aVcVpVWLyAxMICkeU32PrEo59KMqB6ZE9YP2t2ZEAIB/6ahe36O6z1mrslSBcbU/mfucGWpeZg2nrLkPkADGU90n3jHcaRNZVM3MoUP143rqa8IMAD+0zW+aVzcT1HNmqK0PwsXN1644KXWqTW+AWmctVEnCRFZGquffU0JWS7XKSAgYftrJv8fBDf1Hp/iyz8FH/SPbdtLxjwOv6o25HQtaon51y5vE/0XfJQ+a/8I/PuvkmXFAZOdGQnDubXrcb/xpz15yG4ZhIIBSRxAt6+PYmPvfskmTwu6mzSbAjMB3AmFgUSQdQgghhBBCCGEqw933YYwOd18X07Ns+Nb5Dt8qHspqchJekpFpBS9ysa4A69kTfhS+e/S3DSD9WAdOh2m50aaacXLTAolUN5MyNFIlO5rw0TNO1aSIpAqTckSqH+CR6gc4b/GaJFVwTTCrbqo7wDqyJt1UMy4q08eaMUmqTNvAVnBRTErDL5VkRdy8ALztyb8gQWwPYDcoUNtZdSjIpmWFAo5q/74FAtTKqtkGflzjySQlQO5n4F0FO7UO4CGDHNUgPU1zpdZWSUwCek/V05LASzXUOwepKnr9n0Yv4FN3yYfqKntPTPreTNMXsxERrTaKguoAAAAASUVORK5CYII="
									/>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<template v-if="!MBWayPaymentDone">
									<v-form ref="form" v-model="validPhoneNumber">
										<v-row no-gutters>
											<v-col cols="12" md="4">
												<v-text-field
													v-model="mobilePhone"
													placeholder="+351"
													:label="$gettext('Mobile Number')"
													class="px-2"
													outlined
													:rules="[
														() => !!mobilePhone || $gettext('Required'),
														() => !!mobilePhone && mobilePhone.length == 9 || $gettext('Invalid number')
													]"
												/>
											</v-col>
										</v-row>
									</v-form>
									<v-btn color="white" class="mt-0" @click="makePaymentMBWay" :loading="MBWayLoading">
										<translate>Make Payment</translate>
									</v-btn>
									<p class="my-4 font-weight-thin" key="notif">
										<b>
											<translate>Note</translate>:
										</b>
										<translate>A notification will be sent to your mobile phone. Accept the transaction with your MB WAY PIN.</translate>
									</p>
								</template>
								<template v-else>
									<template v-if="!MBWayPaymentError">
										<p v-translate class="font-weight-thin">Payment request sent successfully!</p>
										<p v-translate class="font-weight-thin">
											After you accept the transaction and it is processed, you will have access to the plan. Check the "Payments" section in the "Subscriptions" tab to see the status of your payment.
										</p>
									</template>
									<template v-else>
										<p v-translate key="mbway">Error! Try again later</p>
									</template>
								</template>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel :disabled="paymentDone">
							<v-expansion-panel-header expand-icon="mdi-menu-down">
								<v-row no-gutters align="center">
									<img
										style="max-width:90px; max-height: 30px;"
										src="https://www.easypay.pt/static/img/5.656e359.png"
									/>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-btn
									v-if="!CCPaymentError"
									color="white"
									class="my-4"
									:loading="CCLoading"
									@click="makePaymentCC"
								>
									<translate>Make Payment</translate>
								</v-btn>
								<p v-else v-translate key="cc">Error! Try again later</p>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel :disabled="paymentDone">
							<v-expansion-panel-header expand-icon="mdi-menu-down">
								<v-row no-gutters align="center">
									<img
										style="max-width:90px; max-height: 30px;"
										:src="require('../../assets/images/' + 'bank_transfer_logo.png')"
									/>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<template v-if="!BankTransferPaymentDone">
									<v-btn
										color="white"
										class="my-4"
										:loading="BankTransferLoading"
										@click="makePaymentBankTransfer"
									>
										<translate>Generate Payment</translate>
									</v-btn>
									<p class="my-4 font-weight-thin" key="no-tax">
										<b>
											<translate>Note</translate>:
										</b>
										<translate>If your current plan is about to expire, we will immediately give you 3 days which will be debited later when the payment is completed.</translate>
									</p>
								</template>
								<template v-else>
									<template v-if="!BankTransferPaymentError">
										<p>
											<b v-translate>Beneficiary</b>:
											{{beneficiary}}
										</p>
										<p>
											<b v-translate>IBAN</b>:
											{{iban}}
										</p>
										<p>
											<b v-translate>BIC</b>:
											{{bic}}
										</p>
										<p>
											<b v-translate>Amount:</b>
											{{BankTransferAmount}} €
										</p>
										<p v-translate class="font-weight-thin">
											After making the transfer, you must add a proof of payment. Check the "Payments" section in the "Subscriptions" tab to see the status of your payment.
										</p>
									</template>
									<template v-else>
										<p v-translate class="font-weight-thin red--text">Error! Try again later</p>
									</template>
								</template>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
					<v-row no-gutters class="mt-6 px-6">
						<v-spacer></v-spacer>
						<v-btn v-if="!(MBPaymentDone || MBWayPaymentDone || BankTransferPaymentDone)" color="primary" @click="showPaymentMethods = false">
							<translate>Cancel</translate>
						</v-btn>
						<v-btn v-else color="primary" :to="{name: 'modules'}">
							<translate>Back</translate>
						</v-btn>
					</v-row>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import axios from "axios";

export default {
	name: "BuyModule",
	components: {
		Breadcrumbs
	},
	data: () => ({
		validPhoneNumber: false,
		mobilePhone: null,
		MBLoading: false,
		MBWayLoading: false,
		CCLoading: false,
		BankTransferLoading: false,
		MBPaymentDone: false,
		MBWayPaymentDone: false,
		BankTransferPaymentDone: false,
		MBPaymentError: false,
		MBWayPaymentError: false,
		CCPaymentError: false,
		BankTransferPaymentError: false,
		MBEntity: "",
		MBReference: "",
		MBAmount: "",
		iban: "",
		beneficiary: "",
		bic: "",
		showPaymentMethods: false,
		cartItems: [],
		upgrade: false,
		total: 0,
		paymentDone: false,
		discountCode: null,
		invalidCode: false,
		invalidUpgradeCode: false,
		validForm: false,
		loadingCode: false,
		isSMS: false
	}),
	methods: {
		makePaymentMB() {
			this.MBLoading = true;
			var request = {};
			request["items"] = this.$store.getters.items;
			request["total_price"] = this.$store.getters.total.priceWithDiscount;
			request["method"] = "mb";
			request["plan"] = this.$store.getters.cartPlan;
			request["discount_code"] = this.$store.getters.discountCode;
			axios
				.post("buy-subscription-plan", request)
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						this.MBPaymentDone = true;
						if (response.data.status === "ok") {
							this.paymentDone = true;
							this.MBEntity = response.data.method.entity;
							this.MBReference = response.data.method.reference;
							this.MBAmount = response.data.method.value;
							this.$store.dispatch("RESET_CART");
						} else if (response.data.status === "error") {
							this.MBPaymentError = true;
						}
						this.MBLoading = false;
					}
				})
				.catch(error => {
					console.log(error);
					this.MBLoading = false;
					this.MBPaymentDone = true;
					this.MBPaymentError = true;
				});
		},
		validateMobilePhone() {
			return this.$refs.form.validate();
		},
		makePaymentMBWay() {
			if (this.validateMobilePhone()) {
				this.MBWayLoading = true;
				var request = {};
				request["items"] = this.$store.getters.items;
				request["total_price"] = this.$store.getters.total.priceWithDiscount;
				request["method"] = "mbw";
				request["phone_number"] = this.mobilePhone;
				request["plan"] = this.$store.getters.cartPlan;
				request["discount_code"] = this.$store.getters.discountCode;
				axios
					.post("buy-subscription-plan", request)
					.then(response => {
						if (response.status === 200) {
							this.MBWayPaymentDone = true;
							if (response.data.status === "ok") {
								this.paymentDone = true;
								this.MBWayLoading = false;
								this.$store.dispatch("RESET_CART");
							} else if (response.data.status === "error") {
								this.MBWayPaymentError = true;
							}
							this.MBWayLoading = false;
						}
					})
					.catch(error => {
						console.log(error);
						this.MBWayLoading = false;
						this.MBWayPaymentDone = true;
						this.MBWayPaymentError = true;
					});
			}
		},
		makePaymentCC() {
			this.CCLoading = true;
			var request = {};
			request["items"] = this.$store.getters.items;
			request["total_price"] = this.$store.getters.total.priceWithDiscount;
			request["method"] = "cc";
			request["plan"] = this.$store.getters.cartPlan;
			request["discount_code"] = this.$store.getters.discountCode;
			axios
				.post("buy-subscription-plan", request)
				.then(response => {
					if (response.status === 200) {
						if (response.data.status === "ok") {
							this.CCLoading = false;
							this.$store.dispatch("RESET_CART");
							window.location.href = response.data.method.url;
						} else if (response.data.status === "error") {
							this.CCPaymentError = true;
						}
						this.CCLoading = false;
					}
				})
				.catch(error => {
					console.log(error);
					this.CCLoading = false;
					this.CCPaymentError = true;
				});
		},
		makePaymentBankTransfer() {
			this.BankTransferLoading = true;
			var request = {};
			request["items"] = this.$store.getters.items;
			request["total_price"] = this.$store.getters.total.priceWithDiscount;
			request["method"] = "bt";
			request["plan"] = this.$store.getters.cartPlan;
			request["discount_code"] = this.$store.getters.discountCode;
			axios
				.post("buy-subscription-plan", request)
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						this.BankTransferPaymentDone = true;
						if (response.data.status === "ok") {
							this.paymentDone = true;
							this.beneficiary = response.data.method.beneficiary;
							this.iban = response.data.method.iban;
							this.bic = response.data.method.bic;
							this.BankTransferAmount = response.data.method.value;
							this.$store.dispatch("RESET_CART");
						} else if (response.data.status === "error") {
							this.BankTransferPaymentError = true;
						}
						this.BankTransferLoading = false;
					}
				})
				.catch(error => {
					console.log(error);
					this.BankTransferLoading = false;
					this.BankTransferPaymentDone = true;
					this.BankTransferPaymentError = true;
				});
		},
		removeItem(item) {
			this.$store.dispatch("REMOVE_ITEM", item);
		},
		useCode() {
			this.invalidCode = false;
			this.invalidUpgradeCode = false;
			if(this.$refs.discountCodeForm.validate()) {
				this.loadingCode = true;
				axios
					.get("/discount-code/" + this.discountCode)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							if(response.data.discount_code.days && this.cartItems[0].upgrade) {
								this.invalidUpgradeCode = true;
							} else {
								this.$store.dispatch('ADD_DISCOUNT_CODE', response.data.discount_code);
								this.discountCode = null;
								this.init();
							}
						} else {
							this.invalidCode = true;
						}
						this.loadingCode = false;
					})
					.catch(error => {
						console.log(error);
						this.loadingCode = false;
					});
			}
		},
		removeCode() {
			this.$store.dispatch('REMOVE_DISCOUNT_CODE');
			this.init();
		},
		init() {
			this.cartItems = this.$store.getters.items;
			this.total = this.$store.getters.total;
			if(this.cartItems[0].upgrade) this.upgrade = true;
			if(this.cartItems[0].type === "sms") this.isSMS = true;
		}
	},
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Modules"),
					disabled: false,
					link: true,
					to: { name: "modules" }
				},
				{
					text: this.$gettext("Cart"),
					disabled: true,
					link: false
				}
			];
		},
		durationOptions() {
			return [{ name: 1 + " " + this.$gettext("Month"), value: 1 }];
		},
		required() {
			return value => !!value || this.$gettext("Required.");
		},
		hasDiscountCode() {
			return this.$store.getters.hasDiscountCode;
		},
		aditionalDays() {
			let aditional = 0;
			if(this.hasDiscountCode) {
				let code = this.$store.getters.discountCode;
				if(code.days) aditional += code.days;
			}
			if(this.$store.getters.spaceSubscriptionPlan) {
				aditional += this.$store.getters.spaceSubscriptionPlan.days_left;
			}
			return aditional;
		},
		priceDiscount() {
			if(this.hasDiscountCode) {
				let code = this.$store.getters.discountCode;
				if(code.amount) return code.amount/100;
			}
			return null;
		},
		endDate() {//ver isto
			var item = this.$store.getters.items[0];
			var today = new Date();
			var days = 30 * item.months + this.aditionalDays;
			today.setDate(today.getDate() + days);
			var dd = String(today.getDate()).padStart(2, "0");
			var mm = String(today.getMonth() + 1 ).padStart(2, "0");
			var yyyy = today.getFullYear();
			var endDate = dd + "/" + mm + "/" + yyyy;
			return endDate;
		}
	},
	mounted() {
		console.log("MOUNTED");
		this.init();
	}
};
</script>